export default __webpack_public_path__ + "static/media/ThumbsDown.fe886eb5.svg";